import React from 'react';
import './style.scss';
import { UnitInputPosition } from '../unitInput';
import { FormError } from 'views/mutual/formErrorScroll';

export enum AlignType{
  center = 'center',
  start = 'start',
  end = 'end',
}

export type CheckInputDataProps = {
  checked?: boolean;
  setChecked?: (value: boolean) => void;
  error?: string;
};

export type CheckInputProps = {
  name: string;
  label: string | React.ReactNode;
  disabled?: boolean;
  align?: AlignType;
} & CheckInputDataProps;

export const CheckInput = (props: CheckInputProps) => {
  const { name, label, checked, setChecked, disabled, align = AlignType.center, error } = props;
  return (
    <>
      <div className="checkInput" 
      style={{ alignItems: align }}>
        <input
          id={name}
          // value={label}
          type="checkbox"
          className="checkInput_input"
          checked={checked}
          onChange={(_) => setChecked && setChecked(!checked)}
          disabled={disabled}
        />
        <label htmlFor={name} className="checkInput_label">
          {label}
        </label>
      </div>
      <FormError className="checkInput_error" error={error} />
    </>
  );
};

export type CheckBoxItemType = {
  label: string;
  checked: boolean;
  disabled?: boolean ;
};

export type MultiCheckInputDataProps = {
  items: CheckBoxItemType[];
  onChangeItems: (items: any[]) => void;
  error?: string;
};

export enum Direction {
  column = 'column',
  row = 'row',
}

export type MultiCheckInputProps = {
  direction : Direction;
  name : string; 
} & MultiCheckInputDataProps;

export const MultiCheckInput = (props: MultiCheckInputProps) => {
  const { items, onChangeItems, error, direction = Direction.column, name = '' } = props;

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newItems = items.map((item) => {
      const newItem = { ...item };
      if (newItem.label === e.target.value) {
        newItem.checked = !newItem.checked;
      }
      return newItem;
    });

    onChangeItems(newItems);
  };

  return (
    <div className={`multiCheckInput multiCheckInput_${direction}`}>
      {items.map((item) => {
        const id = `${name}-${item.label}`;
        return (
          <div className="checkInput">
            <input
              id={id}
              value={item.label}
              type="checkbox"
              className="checkInput_input"
              checked={item.checked}
              onChange={onChange}
              disabled={item.disabled}              
            />
            <label htmlFor={id} className="checkInput_label">
              {item.label}
            </label>
          </div>
        );
      })}
      <FormError className="multiCheckInput_error" error={error} />
    </div>
  );
};

export type UnitMultiCheckInputProps = {
  unit: UnitInputPosition;
  label: string;
} & MultiCheckInputProps;

export const UnitMultiCheckInput = (props: UnitMultiCheckInputProps) => {
  const { unit, label } = props;
  return (
    <>
      <div className="unitMultiCheckInput">
        <div className={`unitMultiCheckInput_unit ${unit}`}>{label}</div>
        <MultiCheckInput {...props} />
      </div>
    </>
  );
};
